import React, { Component } from 'react';
import { Modal } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import { QRCodeCanvas } from 'qrcode.react';
import HTTP from '../../script/service';
import Util from '../../script/util';
import './CodePay.scss';

class CodePay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      // payType: 2, //微信2 支付宝1
      payType: 5, //H5 微信5 支付宝7
      param: null,
      success: 0,
      lastTime: 0,
    };
  }
  show = (param) => {
    if (param?.payType) {
      // todo PC payType 1:支付宝 2:微信
      // todo H5 payType 5:微信 7:支付宝
      // todo 由于现在 PC 支付走的是 H5 支付方式，所以替换一下
      if (param.payType === 1) {
        // 7
        param.payType = 7;
      } else if (param.payType === 2) {
        // 5
        param.payType = 5;
      }
    }
    this.setState(
      {
        visible: true,
        orderEndTime: param.endTime || 180,
        param: param,
        success: 0,
      },
      () => {
        this.changeTime();
      }
    );
  };
  changeTime = () => {
    const { orderEndTime, visible, success, param } = this.state;
    //已关闭跳出
    if (!visible) return false;
    //支付成功和支付超时跳出
    if (success === 1 || success === 2) return false;
    if (orderEndTime > 0) {
      HTTP._is_play_back({
        orderId: param.orderId,
        uid: param.uid,
      }).then((res) => {
        if (res.code == 200 && res.data) {
          this.setState(
            {
              success: 1,
              orderEndTime: 0,
              lastTime: 4,
            },
            () => {
              this.props.successCallback && this.props.successCallback(param);
              this.changeLastTime();
            }
          );
        } else {
          this.setState({
            success: 0,
            orderEndTime: orderEndTime - 3,
          });
          this.timer = setTimeout(this.changeTime, 2000);
        }
      });
    } else {
      this.setState({
        success: 2,
        orderEndTime: 0,
      });
    }
  };
  changeLastTime = () => {
    const { lastTime } = this.state;
    if (lastTime <= 0) {
      this.hide();
    } else {
      this.setState(
        {
          lastTime: lastTime - 1,
        },
        () => {
          this.timer1 = setTimeout(this.changeLastTime, 1000);
        }
      );
    }
  };
  hide = () => {
    this.setState({
      visible: false,
    });
  };
  componentWillUnmount() {
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
  }
  render() {
    const { param, success } = this.state;
    return (
      <Modal
        open={this.state.visible}
        wrapClassName="daidai-modal-style"
        centered={true}
        title="钻石充值"
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="440px"
        onCancel={this.hide}
        zIndex={1006}
      >
        <div className="code-pay-plan">
          {param ? (
            <div className="form-content">
              {success === 1 ? (
                <div className="form-html">
                  <div className="success-plan">
                    <div className="icon-row">
                      <CheckCircleFilled />
                    </div>
                    <div className="row-text-1">支付成功</div>
                    {param.action === 4 ? (
                      <div className="row-text-2">请耐心等待大神确认接单</div>
                    ) : (
                      <div className="row-text-2">
                        你可以在个人中心-我的钱包查看记录
                      </div>
                    )}
                    <div className="row-line">
                      <i className="l" />
                      <i className="r" />
                    </div>
                    <div className="row-foot">
                      <b>{this.state.lastTime}s</b>后弹窗自动关闭
                    </div>
                  </div>
                </div>
              ) : (
                <div className="form-html">
                  <div className="order-info">
                    <p>订单金额</p>
                    <h2>
                      ￥<b>{Util.numberFormat(param.price, 2)}</b>
                    </h2>
                  </div>
                  <div className="code-content">
                    <div className="pay-type">
                      {param.payType === 5 ? (
                        <span className="icon-pay weixin-pay">
                          微信扫码支付
                        </span>
                      ) : (
                        <span className="icon-pay zhifubao-pay">
                          支付宝扫码支付
                        </span>
                      )}
                    </div>
                    {param.url ? (
                      <div className="qcode">
                        <QRCodeCanvas
                          value={param.url}
                          size={200}
                          bgColor={'#d5d5ff'}
                          fgColor={'#2f2765'}
                        />
                      </div>
                    ) : null}
                    {success === 2 ? (
                      <div className="code-replay" onClick={this.hide}>
                        {param.action === 4 ? (
                          <span>
                            <p>订单已失效</p>
                            <p>请重新下单</p>
                          </span>
                        ) : (
                          <span>
                            <p>二维码已失效</p>
                            <p>请重新支付</p>
                          </span>
                        )}
                      </div>
                    ) : null}
                  </div>
                  <div className="code-remark">
                    <p>订单支付成功后，可在“个人中心”查看订单详情</p>
                    <p style={{ color: '#ffc801' }}>
                      支付成功前请勿关闭本窗口, 以防丢单
                    </p>
                  </div>
                </div>
              )}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default CodePay;
